import * as Yup from 'yup';

export const bankFormInitialValues = (initialValues) => {

    return {
        accountName: initialValues?.official_name || '',
        maskNumber:
            initialValues?.mask|| '',
       
    };
};

export const bankFormSchema = Yup.object({
    accountName: Yup.string().required(),
    maskNumber: Yup.string().required(),
    
});
